// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const dockCrane = defineModel({
  id: "dock-crane",
  batchId: "future",
  name: "Dock crane",
  tags: ["building","dock","crane","low-poly","age-of-mcp","future","water"],
  summary: "A jib crane that lifts any heavy cargo between quay, store and cart.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.16, 0.7), color: "#6e4f2e", position: [0, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.14, 0.5, 0.14), color: "#7a5a36", position: [0, 0.55, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.6, 0.5, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.6, 0.5, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.6, 0.5, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.6, 0.5, 0.6] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.16, 0.7), color: "#6e4f2e", position: [0, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.14, 1.1, 0.14), color: "#7a5a36", position: [0, 0.85, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.6, 0.8, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.6, 0.8, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.6, 0.8, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.6, 0.8, 0.6] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.16, 0.7), color: "#6e4f2e", position: [0, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, -0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [-0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.12, 0.1, 0.12), color: "#55504a", position: [0.28, 0.19, 0.28] },
      { geometry: new THREE.BoxGeometry(0.14, 1.3, 0.14), color: "#7a5a36", position: [0, 0.95, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.12, 0.18), color: "#55504a", position: [0, 1.6, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.1, 0.95), color: "#8a6840", position: [0, 1.322273, 0.416852], rotation: [-0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.5, 4), color: "#b9a574", position: [0, 1.606136, 0.208426], rotation: [-0.95, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.4, 4), color: "#b9a574", position: [0, 0.894546, 0.833703] },
      { geometry: new THREE.TorusGeometry(0.06, 0.018, 4, 8), color: "#4a4540", position: [0, 0.674546, 0.833703], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.26, 0.26), color: "#55504a", position: [0, 1.55, -0.3] },
    ] },
  ],
  animations: [],
});
